import React, { FC } from 'react'
import { Text } from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'

const StyledText = styled(Text)`
  ${s({
    pl: 6,
    pt: 4,
    display: 'block',
    fontWeight: 700,
  })}
`

export const FilterHeader: FC<{ label: string }> = ({ label }) => (
  <StyledText data-testid="filter-header">
    <span>{label}</span>
  </StyledText>
)
